import ReactDOM from 'react-dom/client';
import { RouterProvider, createRouter } from '@tanstack/react-router';

import { routeTree } from './routeTree.gen';
import { NotFoundRoute } from './components/app/NotFound';

const router = createRouter({
  routeTree,
  defaultNotFoundComponent: NotFoundRoute,
  notFoundMode: 'root',
  defaultPendingMinMs: 0,
  defaultStructuralSharing: true,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

const rootElement = document.getElementById('portal_root')!;
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(<RouterProvider router={router} />);
}
